import { useId } from 'react';

// Figma "Recreational play" — the vector smiley, colors baked in by design.
const CIRCLE =
  'M11.999 21.375C18.2503 21.375 21.374 17.1777 21.374 12C21.374 6.82233 18.2503 2.625 11.999 2.625C5.74778 2.625 2.62402 6.82233 2.62402 12C2.62402 17.1777 5.74778 21.375 11.999 21.375Z';
const EYE_LEFT =
  'M6.43921 12.1895C6.17718 11.9346 5.75817 11.9369 5.49888 12.1961C5.23735 12.4577 5.23735 12.8817 5.49888 13.1432L5.49984 13.1442L5.50087 13.1452L5.50312 13.1474L5.50842 13.1526L5.52225 13.1658C5.53289 13.1758 5.54642 13.1881 5.56282 13.2025C5.59562 13.2312 5.64006 13.268 5.69618 13.3101C5.80833 13.3942 5.96793 13.4999 6.17521 13.6035C6.59195 13.8119 7.19612 14.0091 7.98152 14.0091C8.76692 14.0091 9.37109 13.8119 9.78783 13.6035C9.99511 13.4999 10.1547 13.3942 10.2669 13.3101C10.323 13.268 10.3674 13.2312 10.4002 13.2025C10.4187 13.1863 10.4368 13.1696 10.4546 13.1526L10.4599 13.1474L10.4622 13.1452L10.4632 13.1442L10.4637 13.1437C10.7252 12.8822 10.7257 12.4577 10.4642 12.1961C10.2049 11.9369 9.78586 11.9346 9.52383 12.1895C9.52282 12.1904 9.52094 12.1921 9.51822 12.1945C9.50916 12.2024 9.49081 12.2179 9.46322 12.2386C9.40795 12.28 9.31641 12.3418 9.18884 12.4055C8.93589 12.532 8.53552 12.6697 7.98152 12.6697C7.42752 12.6697 7.02715 12.532 6.7742 12.4055C6.64663 12.3418 6.55509 12.28 6.49982 12.2386C6.47223 12.2179 6.45388 12.2024 6.44482 12.1945C6.4421 12.1921 6.44023 12.1904 6.43921 12.1895Z';
const EYE_RIGHT =
  'M14.4753 12.1895C14.2133 11.9346 13.7943 11.9369 13.535 12.1961C13.2735 12.4577 13.2735 12.8817 13.535 13.1432L13.536 13.1442L13.537 13.1452L13.5393 13.1474L13.5446 13.1526C13.5624 13.1696 13.5804 13.1863 13.599 13.2025C13.6318 13.2312 13.6762 13.268 13.7323 13.3101C13.8445 13.3942 14.0041 13.4999 14.2113 13.6035C14.6281 13.8119 15.2323 14.0091 16.0177 14.0091C16.803 14.0091 17.4072 13.8119 17.824 13.6035C18.0312 13.4999 18.1908 13.3942 18.303 13.3101C18.3591 13.268 18.4035 13.2312 18.4363 13.2025C18.4528 13.1881 18.4663 13.1758 18.4769 13.1658L18.4961 13.1474L18.4983 13.1452L18.4993 13.1442L18.4998 13.1437C18.7614 12.8822 18.7618 12.4577 18.5003 12.1961C18.241 11.9369 17.822 11.9346 17.56 12.1895C17.5589 12.1904 17.5571 12.1921 17.5544 12.1945C17.5453 12.2024 17.5269 12.2179 17.4994 12.2386C17.4441 12.28 17.3525 12.3418 17.225 12.4055C16.972 12.532 16.5716 12.6697 16.0177 12.6697C15.4637 12.6697 15.0633 12.532 14.8103 12.4055C14.6828 12.3418 14.5912 12.28 14.5359 12.2386C14.5084 12.2179 14.49 12.2024 14.481 12.1945C14.4782 12.1921 14.4764 12.1904 14.4753 12.1895Z';
const BROW_LEFT =
  'M6.6886 7.30375C6.29153 7.68071 6.05141 8.13426 5.95534 8.42248C5.89686 8.59792 5.70723 8.69274 5.53179 8.63426C5.35634 8.57578 5.26153 8.38615 5.32001 8.21071C5.44717 7.82923 5.7428 7.27823 6.22751 6.81807C6.7179 6.35251 7.41097 5.97266 8.31646 5.97266C8.50139 5.97266 8.65131 6.12257 8.65131 6.3075C8.65131 6.49244 8.50139 6.64235 8.31646 6.64235C7.61468 6.64235 7.07997 6.9322 6.6886 7.30375Z';
const BROW_RIGHT =
  'M17.3114 7.30375C17.7085 7.68071 17.9486 8.13426 18.0447 8.42248C18.1031 8.59792 18.2928 8.69274 18.4682 8.63426C18.6437 8.57578 18.7385 8.38615 18.68 8.21071C18.5528 7.82923 18.2572 7.27823 17.7725 6.81807C17.2821 6.35251 16.589 5.97266 15.6835 5.97266C15.4986 5.97266 15.3487 6.12257 15.3487 6.3075C15.3487 6.49244 15.4986 6.64235 15.6835 6.64235C16.3853 6.64235 16.92 6.9322 17.3114 7.30375Z';
const MOUTH =
  'M8.24936 16.8215C8.54525 16.5996 8.96502 16.6595 9.18694 16.9554C9.39412 17.2317 10.3333 18.0269 11.9997 18.0269C13.666 18.0269 14.6052 17.2317 14.8124 16.9554C15.0343 16.6595 15.4541 16.5996 15.75 16.8215C16.0459 17.0434 16.1058 17.4632 15.8839 17.7591C15.4214 18.3757 14.0836 19.3663 11.9997 19.3663C9.91571 19.3663 8.57794 18.3757 8.11542 17.7591C7.89351 17.4632 7.95347 17.0434 8.24936 16.8215Z';

export default function GameTypeCasual({ className }: { className?: string }) {
  const id = `game-type-casual-${useId().replace(/:/g, '')}`;

  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d={CIRCLE} fill={`url(#${id}-0)`} />
      <path d={CIRCLE} fill={`url(#${id}-1)`} />
      <path d={CIRCLE} fill={`url(#${id}-2)`} fillOpacity="0.6" />
      <path d={CIRCLE} fill={`url(#${id}-3)`} />
      <path d={CIRCLE} fill={`url(#${id}-4)`} />
      <path d={CIRCLE} fill={`url(#${id}-5)`} />
      <path d={CIRCLE} fill={`url(#${id}-6)`} />
      <path d={CIRCLE} fill={`url(#${id}-7)`} />
      <path d={CIRCLE} fill={`url(#${id}-8)`} />
      <path d={CIRCLE} fill={`url(#${id}-9)`} />
      <path d={CIRCLE} fill={`url(#${id}-10)`} />
      <path d={CIRCLE} fill={`url(#${id}-11)`} />
      <path d={CIRCLE} fill={`url(#${id}-12)`} />
      <path d={CIRCLE} fill={`url(#${id}-13)`} />
      <path d={CIRCLE} fill={`url(#${id}-14)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={EYE_LEFT} fill={`url(#${id}-15)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={EYE_LEFT} fill={`url(#${id}-16)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={EYE_LEFT} fill={`url(#${id}-17)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={EYE_RIGHT} fill={`url(#${id}-18)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={EYE_RIGHT} fill={`url(#${id}-19)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={EYE_RIGHT} fill={`url(#${id}-20)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={EYE_RIGHT} fill={`url(#${id}-21)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={BROW_LEFT} fill={`url(#${id}-22)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={BROW_RIGHT} fill={`url(#${id}-23)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={MOUTH} fill={`url(#${id}-24)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={MOUTH} fill={`url(#${id}-25)`} />
      <path fillRule="evenodd" clipRule="evenodd" d={MOUTH} fill={`url(#${id}-26)`} />
      <defs>
        <radialGradient
          id={`${id}-0`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.3619 7.31288) rotate(131.878) scale(26.0838)"
        >
          <stop stopColor="#FFF478" />
          <stop offset="0.474827" stopColor="#FFB02E" />
          <stop offset="1" stopColor="#F70A8D" />
        </radialGradient>
        <radialGradient
          id={`${id}-1`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9998 9.65681) rotate(101.31) scale(11.9518 15.308)"
        >
          <stop offset="0.787821" stopColor="#F59639" stopOpacity="0" />
          <stop offset="0.972509" stopColor="#FF7DCE" />
        </radialGradient>
        <radialGradient
          id={`${id}-2`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.3392 10.6614) rotate(135) scale(27.4657)"
        >
          <stop offset="0.314853" stopOpacity="0" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id={`${id}-3`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9998 12.6704) rotate(77.692) scale(18.8499)"
        >
          <stop offset="0.507903" stopColor="#7D6133" stopOpacity="0" />
          <stop offset="1" stopColor="#715B32" />
        </radialGradient>
        <radialGradient
          id={`${id}-4`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.3346 12.3356) rotate(55.7131) scale(8.91602 6.46278)"
        >
          <stop stopColor="#FFB849" />
          <stop offset="1" stopColor="#FFB847" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-5`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.0134 13.3401) rotate(9.86581) scale(7.81711)"
        >
          <stop stopColor="#FFA64B" />
          <stop offset="0.900412" stopColor="#FFAE46" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-6`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0043 11.3311) rotate(43.9708) scale(39.5475)"
        >
          <stop offset="0.185425" stopOpacity="0" />
          <stop offset="1" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id={`${id}-7`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.0844 8.3655) rotate(66.1408) scale(1.01647 0.906533)"
        >
          <stop stopColor="#E7982E" />
          <stop offset="1" stopColor="#E39632" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-8`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.3762 7.37648) rotate(50.1231) scale(2.01082 0.807326)"
        >
          <stop stopColor="#E7982E" />
          <stop offset="1" stopColor="#E39632" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-9`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.3413 6.85177) rotate(30.9638) scale(1.85766 1.02777)"
        >
          <stop stopColor="#E2981B" />
          <stop offset="1" stopColor="#FFDC64" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-10`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.7439 6.51327) rotate(-1.61354) scale(1.41429 1.0578)"
        >
          <stop stopColor="#E2981B" />
          <stop offset="1" stopColor="#FFDC64" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-11`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.24007 7.96187) rotate(-35.7653) scale(3.17646 1.41057)"
        >
          <stop stopColor="#D59A13" />
          <stop offset="1" stopColor="#D59A13" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-12`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.0698 13.4289) rotate(4.05579) scale(3.37187 1.49734)"
        >
          <stop offset="0.312678" stopColor="#D67B36" />
          <stop offset="1" stopColor="#F79A38" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-13`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.6164 13.3483) scale(2.98888 1.32727)"
        >
          <stop offset="0.40792" stopColor="#D67B36" />
          <stop offset="1" stopColor="#D59A13" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-14`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.65778 8.96928) rotate(-45) scale(2.47895)"
        >
          <stop stopColor="#FFC149" />
          <stop offset="0.849604" stopColor="#FFC44A" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id={`${id}-15`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.98152 12) rotate(90) scale(2.21837 4.01818)"
        >
          <stop offset="0.339623" stopColor="#4E3225" />
          <stop offset="0.55814" stopColor="#56424D" />
          <stop offset="0.867925" stopColor="#502A53" />
        </radialGradient>
        <radialGradient
          id={`${id}-16`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.31281 13.0045) rotate(-177.107) scale(4.29218 2.24813)"
        >
          <stop offset="0.705029" stopColor="#4D3231" stopOpacity="0" />
          <stop offset="1" stopColor="#322020" />
        </radialGradient>
        <radialGradient
          id={`${id}-17`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.2783 12.4469) rotate(136.042) scale(0.681201 1.48504)"
        >
          <stop stopColor="#66515A" />
          <stop offset="1" stopColor="#58464D" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id={`${id}-18`}
          x1="16.8213"
          y1="12.5023"
          x2="16.6638"
          y2="13.4471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#52383E" />
          <stop offset="1" stopColor="#432A35" />
        </linearGradient>
        <radialGradient
          id={`${id}-19`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0177 12) rotate(90) scale(2.21837 4.01818)"
        >
          <stop offset="0.339623" stopColor="#4E3225" />
          <stop offset="0.55814" stopColor="#56424D" />
          <stop offset="0.867925" stopColor="#502A53" />
        </radialGradient>
        <radialGradient
          id={`${id}-20`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.3489 13.0045) rotate(-177.107) scale(4.29218 2.24813)"
        >
          <stop offset="0.705029" stopColor="#4D3231" stopOpacity="0" />
          <stop offset="1" stopColor="#322020" />
        </radialGradient>
        <radialGradient
          id={`${id}-21`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.3145 12.4469) rotate(136.042) scale(0.681201 1.48504)"
        >
          <stop stopColor="#66515A" />
          <stop offset="1" stopColor="#58464D" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id={`${id}-22`}
          x1="5.86091"
          y1="8.91932"
          x2="5.86091"
          y2="7.71387"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0299084" stopColor="#524049" />
          <stop offset="1" stopColor="#4A2C42" />
        </linearGradient>
        <linearGradient
          id={`${id}-23`}
          x1="18.1391"
          y1="8.91932"
          x2="18.1391"
          y2="7.71387"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0299084" stopColor="#524049" />
          <stop offset="1" stopColor="#4A2C42" />
        </linearGradient>
        <radialGradient
          id={`${id}-24`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9997 16.0178) rotate(90) scale(3.68333 5.63787)"
        >
          <stop offset="0.34763" stopColor="#241A1A" />
          <stop offset="0.628228" stopColor="#57444A" />
          <stop offset="1" stopColor="#4E2553" />
          <stop offset="1" stopColor="#502A56" />
        </radialGradient>
        <radialGradient
          id={`${id}-25`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9997 16.0922) rotate(90) scale(3.57172 5.27178)"
        >
          <stop offset="0.517632" stopColor="#4E2553" />
          <stop offset="0.702876" stopColor="#5E425A" />
          <stop offset="1" stopColor="#4E2553" />
          <stop offset="1" stopColor="#4E2553" />
        </radialGradient>
        <radialGradient
          id={`${id}-26`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9997 18.1066) rotate(90) scale(1.62572 7.61912)"
        >
          <stop offset="0.645531" stopColor="#4C2746" stopOpacity="0" />
          <stop offset="1" stopColor="#4E2847" />
        </radialGradient>
      </defs>
    </svg>
  );
}
